import FormattedMessage from 'I18n/components/FormattedMessage';
import { RefreshIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
export function RefreshEligibilityButton({
  onRefresh,
  isRefreshing = false
}) {
  return /*#__PURE__*/_jsx(IconButton, {
    disabled: isRefreshing,
    onClick: () => onRefresh(),
    size: "small",
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.moveToSupportCard.tooltip.refresh"
    }),
    use: "link",
    children: /*#__PURE__*/_jsx(RefreshIcon, {})
  });
}